import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';
import { DataSourceTypeSchema, LotterySchema } from './lottery';

const lotteryTemplateOnlyFields = Type.Object({
  id: Type.String(),
  title: Type.String(),
  description: Type.String(),
  prize: Type.Array(Type.Literal('MANUAL')),
});

const requiredRootLevelFieldsFromLottery = Type.Pick(LotterySchema, ['lotteryType']);

const nestedRequiredFieldsFromLottery = Type.Object({
  dataSource: Type.Object({
    dataSourceType: DataSourceTypeSchema,
  }),
});

const optionalFieldsFromLottery = Type.Pick(LotterySchema, ['drawConstraints']);

// const optionalNestedFieldsFromLottery = Type.Object({
//   Not working as expected? All its props are still required
//   dataSource: Type.Optional(DataSourceSchema),
// });

export type LotteryTemplate = Static<typeof LotteryTemplateSchema>;
export const LotteryTemplateSchema = Type.Intersect(
  [
    lotteryTemplateOnlyFields,
    requiredRootLevelFieldsFromLottery,
    nestedRequiredFieldsFromLottery,
    optionalFieldsFromLottery,
    // optionalNestedFieldsFromLottery,
  ],
  { $id: 'LotteryTemplateSchema' }
);
